var karlsbader = "'KarlsbaderGrotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif";
var fontFamily = {
  "default": karlsbader
};
var fontSize = {
  huge: '1.5rem',
  large: '1rem',
  medium: '0.875rem',
  small: '0.75rem',
  tiny: '0.625rem'
};
var fontWeight = {
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800'
};
var fontStyle = {
  normal: 'normal',
  italic: 'italic'
};
var lineHeight = {
  "default": '166.667%',
  neutralized: '120%'
};

export { fontFamily, fontSize, fontStyle, fontWeight, karlsbader, lineHeight };
